module.exports = __webpack_public_path__ + "montana.jpg?35131b11d20e69537145b88be210e97f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/montana.jpg
// module id = 137
// module chunks = 0